/**
 * @generated SignedSource<<1adc04cc962a9c62bebdd0e0ffd7ec5e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StakeholderInternalSetInputObject = {
  internal: boolean;
  stakeholderId: string;
};
export type categorizePage_StakeholderInternalSetMutation$variables = {
  input: StakeholderInternalSetInputObject;
};
export type categorizePage_StakeholderInternalSetMutation$data = {
  readonly stakeholderInternalSet: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly stakeholder: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type categorizePage_StakeholderInternalSetMutation = {
  response: categorizePage_StakeholderInternalSetMutation$data;
  variables: categorizePage_StakeholderInternalSetMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Stakeholder",
  "kind": "LinkedField",
  "name": "stakeholder",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "categorizePage_StakeholderInternalSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakeholderInternalSetMutationPayload",
        "kind": "LinkedField",
        "name": "stakeholderInternalSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "categorizePage_StakeholderInternalSetMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StakeholderInternalSetMutationPayload",
        "kind": "LinkedField",
        "name": "stakeholderInternalSet",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "578afcaa580aaa2bb436de073c3d6b87",
    "id": null,
    "metadata": {},
    "name": "categorizePage_StakeholderInternalSetMutation",
    "operationKind": "mutation",
    "text": "mutation categorizePage_StakeholderInternalSetMutation(\n  $input: StakeholderInternalSetInputObject!\n) {\n  stakeholderInternalSet(input: $input) {\n    stakeholder {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "57034e16806709957e9abf97bfd22938";

export default node;
